'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _postJob = require('./post-job.html');

var _postJob2 = _interopRequireDefault(_postJob);

var _postJob3 = require('./post-job.controller');

var _postJob4 = _interopRequireDefault(_postJob3);

require('./post-job.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postJobComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template: _postJob2.default,
  controller: _postJob4.default,
  controllerAs: 'vm'
};

exports.default = postJobComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/post-job/post-job.component.js
 **/